<template>
	<div>
		<div class="c-controls__group">
			<label class="c-controls__label">Team</label>
			<select v-model="team" v-on:change="chooseTeam()">
				<option v-for="team in teams" :key="team.uuid" :value="team.uuid">
					{{ team.name }}
				</option>
			</select>
		</div>

		<div class="c-controls">
			<div class="c-videocontrols">
				<button @click="play">
					<svg class="icon icon_play"><use xlink:href="#icon_play"></use></svg>
				</button>
				<button @click="stop">
					<svg class="icon icon_stop"><use xlink:href="#icon_stop"></use></svg>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import VideoControl from '../controls/VideoControl';
import BaseSlide from './BaseSlide';

export default {
	name: 'NieuwsmakerPresentationSlide',
	mixins: [BaseSlide],
	components: {
		VideoControl,
	},
	data() {
		return {
			team: null,
		};
	},
	computed: {
		teams() {
			return this.$actions.getTeams();
		},
	},
	methods: {
		chooseTeam() {
			this.subcommand('nieuwsmaker.team', this.team);
			this.stop();
		},
		play() {
			this.subcommand('nieuwsmaker.play');
		},
		stop() {
			this.subcommand('nieuwsmaker.stop');
		},
	},
};
</script>

<style></style>
